export const MAX_FRAME_WIDTH = '812px';